import { Component, Host, h, Prop} from '@stencil/core';

/**
 * @slot media - Shadow DOM Slot for the Contact Image / Picture
 * @slot links - Place the contact links here to display as a list
 */
@Component({
  tag: 'vds-sidebar-contact',
  styleUrl: 'vds-sidebar-contact.scss',
  shadow: true,
})
export class VdsSidebarContact {

  /**
   * Persons name
   * Mandatory: yes
   */
  @Prop() headline = '';

  /**
   * Persons position
   * Mandatory: yes
   */
  @Prop() subline = '';

  render() {
    return (
      <Host>
        <div class="relative bg-white border-2 border-grey-lighter border-b-8 border-b-yellow rounded-[5px]">
          <div class="p-[50px]">
            <slot name="media"></slot>
          </div>
          <div class="px-[30px] pb-[30px]">
            <h3 class="font-heavy text-h3-mobile sm:text-h3-tablet lg:text-h3-desktop text-grey uppercase break-words" innerHTML={ this.headline }></h3>
            <span class="block text-s3 text-grey break-words" innerHTML={ this.subline }></span>
          </div>
          <div class="px-[30px] pb-[30px] break-words">

            <slot name="links"></slot>

          </div>
        </div>
      </Host>
    );
  }

}
